const footerPl = {
    "follow_us": "Obserwuj nas!",
    "all_rights_reserved": "2024 Code Kitchen Kft. Wszelkie prawa zastrzeżone.",
    "terms_and_conditions": "Warunki korzystania z serwisu",
    "privacy_policy": "Polityka prywatności"
};

export default footerPl;
